import "./form-package-accommodation.scss";

import { PackageAccommodationFormSchema } from "@factory/form/form.rule";
import CheckboxControl from "@shared/ui/hook-form/checkbox-control/checkbox-control";
import DropdownControl from "@shared/ui/hook-form/dropdown-control/dropdown-control";
import InputControl from "@shared/ui/hook-form/input-control/input-control";
import InputDateControl from "@shared/ui/hook-form/input-date-control/input-date-control";
import InputDigitControl from "@shared/ui/hook-form/input-digit-control/input-digit-control";
import { useState } from "react";
import { useFormContext } from "react-hook-form";
import { useParams } from "react-router-dom";

import { GetHotelModel } from "../../../factory/model/query-model-hotel";
import { GetRoomTypeModel } from "../../../factory/model/query-model-room-type";
import { useQyGetHotel } from "../../../factory/query/hotel.query";
import { useQyGetRoomType } from "../../../factory/query/room-type.query";
import { LabelValue } from "../../../shared/models/label-value.interface";

type InputFormSchema = PackageAccommodationFormSchema;
interface HotelRoomMap {
  [hotelCode: string]: LabelValue[];
}
export function FormPackageAccommodation() {
  const { control, setValue, watch, getValues } =
    useFormContext<PackageAccommodationFormSchema>();
  const { packageId } = useParams();
  const [hotels, setHotels] = useState<LabelValue[]>([]);
  const [unmappedHotels, setUnmappedHotels] = useState<GetHotelModel[]>([]);
  const [roomTypes, setRoomTypes] = useState<HotelRoomMap>({});
  const [unmappedRoomTypes, setUnmappedRoomTypes] = useState<
    GetRoomTypeModel[]
  >([]);
  const hotelCode = watch(`hotel`);

  setValue("package", packageId);

  // THIS IS THE LOCAL QUERY DECLARATION
  useQyGetHotel("", 9999, 0, undefined, undefined, true, (response) => {
    const mappedSuggestions = (response?.data || [])
      .map((item) => ({
        label: `${item.name}`,
        value: item.code,
      }))
      .filter((x) => !!x.label);
    // Set the suggestions for the dropdown control
    setUnmappedHotels(response?.data || []);
    setHotels(mappedSuggestions);
  });
  useQyGetRoomType("", 9999, 0, undefined, undefined, true, (response) => {
    const mappedSuggestions = (response?.data || [])
      .map((item) => ({
        hotel: item.hotel,
        label: `${item.name}`,
        value: item.code,
      }))
      .filter((x) => !!x.label);
    setUnmappedRoomTypes(response?.data || []);
    // Set the suggestions for the dropdown control
    const groupedRoomTypes = groupByHotel(mappedSuggestions);
    setRoomTypes(groupedRoomTypes);
  });

  // THIS ARE THE LOCAL FUNCTIONS
  const groupByHotel = (
    mappedSuggestions: Array<{ hotel: string; label: string; value: string }>
  ) => {
    return mappedSuggestions.reduce((acc: HotelRoomMap, item) => {
      const hotelUuid = item.hotel;

      if (!acc[hotelUuid]) {
        acc[hotelUuid] = [];
      }

      acc[hotelUuid].push({
        label: item.label,
        value: item.value,
      });

      return acc;
    }, {});
  };
  return (
    <div id="FormPackageAccommodation" className="package-accommodation">
      <DropdownControl<InputFormSchema>
        control={control}
        name={`hotel`}
        label="Hotel"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Select a hotel"
        options={hotels}
      />
      <DropdownControl<InputFormSchema>
        control={control}
        name={`roomType`}
        label="Room Type"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Select a room type"
        options={roomTypes[hotelCode || ""] || []}
        onSelect={(value) => {
          const roomType = unmappedRoomTypes.find((rt) => rt.code === value);
          setValue(`price`, roomType?.price || 0);
          setValue(`validFrom`, roomType?.valid_from);
          setValue(`validUntil`, roomType?.valid_until);
        }}
      />
      <InputDigitControl<InputFormSchema>
        control={control}
        name="numPeople"
        label="Num_people"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter numPeople"
      />
      <InputControl<InputFormSchema>
        control={control}
        name="unit"
        label="Unit"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter unit"
      />
      <InputDateControl<InputFormSchema>
        control={control}
        name="validFrom"
        label="Valid_from"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter validFrom"
      />
      <InputDateControl<InputFormSchema>
        control={control}
        name="validUntil"
        label="Valid_until"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter validUntil"
      />
      {/* <InputControl<InputFormSchema>
        control={control}
        name="name"
        label="Name"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter name"
      /> */}
      <InputDigitControl<InputFormSchema>
        control={control}
        name="price"
        label="Price"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter price"
      />
      <InputControl<InputFormSchema>
        control={control}
        name="description"
        label="Description"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter description"
      />
    </div>
  );
}

export default FormPackageAccommodation;
